import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const getForSearch = (params) => {
  // if (params.mode === "officer") {
  //   console.log("Url getForSearch - officer",
  //     appsettings.ocpbComplaintAPIUrl + "api/clue/Foruser",
  //     params
  //   )
  //   return axiosGet(
  //     appsettings.ocpbComplaintAPIUrl + "api/clue/Foruser",
  //     params
  //   );
  // } else {
  //   console.log("Url getForSearch",
  //     appsettings.ocpbComplaintAPIUrl + "api/clue/ForSearch",
  //     params
  //   )
  //   return axiosGet(
  //     appsettings.ocpbComplaintAPIUrl + "api/clue/ForSearch",
  //     params
  //   );
  // }
  console.log("Url getForSearch",
    appsettings.ocpbComplaintAPIUrl + "api/clue/ForSearch",
    params
  )
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/clue/ForSearch",
    params
  );
};

const getAIMaster = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/clue/AIMaster",
    params
  );
};

const getById = (id) => {
  const params = {
    id,
  };

  console.log("url", 
    appsettings.ocpbComplaintAPIUrl + "api/clue/GetById",
    params
  );
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/clue/GetById",
    params
  );
};

const updateItem = (params) => {
  console.log("Url", 
    appsettings.ocpbComplaintAPIUrl +
    "api/Clue/Update?userId=" +
    userData.userId() +
    "&officerInput=true",
    params
  );
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Clue/Update?userId=" +
      userData.userId() +
      "&officerInput=true",
    params
  );
};

const updateProcess = (params) => {
  console.log("Url", 
    appsettings.ocpbComplaintAPIUrl + "api/Clue/UpdateProcess",
    params
  );
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Clue/UpdateProcess", 
    params
  );
};

const deleteClue = (clueId, userId) => {
  
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Clue/Delete?clueId=" + clueId + "&userId=" + userId
  );
};

export { 
  getForSearch, 
  getById, 
  getAIMaster,

  updateItem,
  updateProcess,
  deleteClue,
};
